import { defineStore } from 'pinia'
import { ref } from 'vue'
import client from '../api/client.js'

const mp = (path) => client.get(`/marketplace${path}`)
const mpPost = (path, data) => client.post(`/marketplace${path}`, data)
const mpPut = (path, data) => client.put(`/marketplace${path}`, data)
const mpDel = (path) => client.delete(`/marketplace${path}`)

export const useOrderStore = defineStore('order', () => {
  const order = ref(null)
  const orders = ref([])
  const loading = ref(false)
  const error = ref(null)

  async function create(data) {
    loading.value = true
    try {
      const { data: result } = await mpPost('/orders', data)
      order.value = result
      orders.value.unshift(result)
      return result
    } catch (e) { error.value = e.message; throw e } finally { loading.value = false }
  }

  async function get(orderId) {
    loading.value = true
    try {
      const { data } = await mp(`/orders/${orderId}`)
      order.value = data
      return data
    } catch (e) { error.value = e.message; throw e } finally { loading.value = false }
  }

  async function getByNumber(orderNumber) {
    try { const { data } = await mp(`/orders/number/${orderNumber}`); return data } catch { return null }
  }

  async function getByShop(shopId) {
    loading.value = true
    try {
      const { data } = await mp(`/orders/shop/${shopId}`)
      orders.value = data
      return data
    } catch { return [] } finally { loading.value = false }
  }

  async function getByBuyer(buyerId) {
    loading.value = true
    try {
      const { data } = await mp(`/orders/buyer/${buyerId}`)
      orders.value = data
      return data
    } catch { return [] } finally { loading.value = false }
  }

  async function update(orderId, data) {
    try { const { data: result } = await mpPut(`/orders/${orderId}`, data); order.value = result; return result } catch (e) { error.value = e.message; throw e }
  }

  async function markPaid(orderId) {
    try { const { data } = await mpPost(`/orders/${orderId}/paid`); order.value = data; return data } catch (e) { error.value = e.message; throw e }
  }

  async function allocate(orderId) {
    try { await mpPost(`/orders/${orderId}/allocate`) } catch (e) { error.value = e.message; throw e }
  }

  async function confirm(orderId) {
    try { const { data } = await mpPost(`/orders/${orderId}/confirm`); order.value = data; return data } catch (e) { error.value = e.message; throw e }
  }

  async function startFulfillment(orderId) {
    try { await mpPost(`/orders/${orderId}/fulfillment/start`) } catch (e) { error.value = e.message; throw e }
  }

  async function completeFulfillment(orderId) {
    try { const { data } = await mpPost(`/orders/${orderId}/fulfillment/complete`); order.value = data; return data } catch (e) { error.value = e.message; throw e }
  }

  async function cancel(orderId) {
    try { const { data } = await mpPost(`/orders/${orderId}/cancel`); order.value = data; return data } catch (e) { error.value = e.message; throw e }
  }

  async function refund(orderId) {
    try { const { data } = await mpPost(`/orders/${orderId}/refund`); order.value = data; return data } catch (e) { error.value = e.message; throw e }
  }

  async function dispute(orderId) {
    try { const { data } = await mpPost(`/orders/${orderId}/dispute`); order.value = data; return data } catch (e) { error.value = e.message; throw e }
  }

  async function listLines(orderId) {
    try { const { data } = await mp(`/orders/${orderId}/lines`); return data } catch { return [] }
  }

  return {
    order, orders, loading, error,
    create, get, getByNumber, getByShop, getByBuyer, update, markPaid,
    allocate, confirm, startFulfillment, completeFulfillment, cancel,
    refund, dispute, listLines,
  }
})
